module.exports = __webpack_public_path__ + "media/images/clinton.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/media/images/clinton.jpg
 ** module id = 34
 ** module chunks = 0
 **/